export const CLASS_NAMES = {
  documentContainer:
    'flex flex-col bg-neutral-100 md:w-full h-full overflow-hidden -mx-2 mt-10 md:m-0 md:mt-6 min-h-100',
  documentPadding:
    'flex flex-1 w-full p-2 max-w-120 md:max-w-none mx-auto md:mx-0',
  document: 'mx-auto max-w-full',
};

export const PLACEHOLDER_TEXT =
  "Hang tight, we're just loading your documents in";
